import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { AnimationWrapper } from './views/animate';
import { CarMarket } from './views/CarMarket';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<AnimationWrapper>
			<Background />
			<CarMarket />
		</AnimationWrapper>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.CarMarket)
	.setHudVisible(false)
	.setTransitionTime(600)
	.build();

export default Layout;
